import AxiosDB from "@/config/axios2";
import { createContext, useContext, useState, useEffect } from "react";
const { sha256 } = require("js-sha256");

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));


  useEffect(() => {
    if (token) {
      AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      setLoading(false);
    }
  }, [token]);


  // Check if user is already logged in (from localStorage)
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    let encryptedPassword = sha256(password).toString();

    const response = await AxiosDB.post(`/auth/login`, { username: email, encryptedPassword, type: 'login' });
    const { token, user } = response.data;

    localStorage.setItem('token', token);
    setToken(token);
    setUser({
      ...user,
      name: user.nombre,
      role: user.rol,
      username: email
    });
    AxiosDB.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    return user;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
